import React, { Fragment, Suspense } from "react";
import Preloader from "../elements/Preloader";
import SEO from "../components/SEO";
import seoData from "../data/seoData";
const Breadcrumb = React.lazy(() => import("../components/Breadcrumb"));
const ContactOne = React.lazy(() => import("../components/ContactOne"));
const FaqOne = React.lazy(() => import("../components/FaqOne"));
const FooterBottomOne = React.lazy(() =>
  import("../components/FooterBottomOne")
);
const FooterOne = React.lazy(() => import("../components/Footer"));
const NavbarOne = React.lazy(() => import("../components/Navbar"));
const Partner = React.lazy(() => import("../components/Partner"));
const SearchPopup = React.lazy(() => import("../elements/SearchPopup"));
const Faq = () => {
  return (
    <>
      <SEO {...seoData.faq} />
      <Fragment>
        <Suspense fallback={<Preloader />}>
          {/* Search Popup */}
          <SearchPopup />

          {/* Navbar One */}
          <NavbarOne />

          {/* Breadcrumb */}
          <Breadcrumb title={"Sıkça Sorulan Sorular"} h1={true} />

          {/* Faq One */}
          <div className='faq-area pd-top-120 pd-bottom-120'>
            <FaqOne />
          </div>

          {/* Contact One */}
          <div
            className='call-to-contact-area pd-top-140 mt-0'
            style={{ background: "#F9F9F9" }}
          >
            <ContactOne />
          </div>

          {/* Partner One */}
          <Partner />

          {/* Footer One */}
          <FooterOne />

          {/* Footer Bottom One */}
          <FooterBottomOne />
        </Suspense>{" "}
      </Fragment>
    </>
  );
};

export default Faq;
